<div class="authorize_container">
    <div class="auth_content">
        <h6 class="mb-3">{{msg}}</h6>
        <button class="btn btn-primary" (click)="closeWindow()">Close window</button>
    </div>
</div>